import React from 'react';
import { View } from 'react-native';

import { useContentHeight } from '@components/SiteHeader.web';
import Stack, { StackProps } from '@components/Stack';

type PageAreaProps = React.PropsWithChildren<{
    /**
     * When `contain` is true, the PageArea component will take up a
     * maximum of the remaining space below the header but will not
     * extend below the fold of the browser window.
     *
     * When `contain` is false, the PageArea will have a minHeight of
     * the remaining space below the header.
     */
    contain?: boolean;
    /**
     * Renders the `PageArea` with absolute positioning and places it
     * above the `SiteHeader` component
     */
    fullScreen?: boolean;
}> &
    Omit<StackProps, 'sx'>;

const PageArea = React.forwardRef<View, PageAreaProps>(
    ({ contain, fullScreen, children, ...props }, ref) => {
        const contentHeight = useContentHeight();
        const calcedHeight = fullScreen ? '100vh' : contentHeight;
        return (
            <Stack
                background
                ref={ref}
                sx={{
                    width: '100%',
                    position: fullScreen ? 'absolute' : undefined,
                    top: fullScreen ? 0 : undefined,
                    z: fullScreen ? 'drawer' : 'page',
                    mnh: contain ? undefined : calcedHeight,
                    h: contain ? calcedHeight : undefined,
                    overflow: contain ? 'hidden' : undefined
                }}
                {...props}
            >
                {children}
            </Stack>
        );
    }
);

export default PageArea;
